import Link from "next/link";
import {
  TRUCK_LOADING_PRODUCT_SLUGS,
  PRODUCT_CONFIGS,
  type TruckLoadingProductSlug,
} from "@/lib/calculators/truck-loading-merged/product-presets";
import { Chip } from "@/components/ui/chip";
import { CalculatorSection } from "@/components/calculators/shared/calculator-workbench";

interface ProductTypeSelectorProps {
  activeSlug: TruckLoadingProductSlug;
  basePath: string;
}

export function ProductTypeSelector({ activeSlug, basePath }: ProductTypeSelectorProps) {
  return (
    <CalculatorSection title="Product">
      <nav aria-label="Product type">
        <ul className="flex flex-wrap gap-1.5">
          {TRUCK_LOADING_PRODUCT_SLUGS.map((slug) => {
            const isActive = slug === activeSlug;
            return (
              <li key={slug}>
                <Chip asChild tone={isActive ? "selected" : "soft"}>
                  <Link
                    href={`${basePath}/${slug}`}
                    aria-current={isActive ? "page" : undefined}
                  >
                    {PRODUCT_CONFIGS[slug].pluralLabel}
                  </Link>
                </Chip>
              </li>
            );
          })}
        </ul>
      </nav>
    </CalculatorSection>
  );
}
